import React from "react";
import { useTable } from "../../Components/useTable";
import { useParams } from "react-router-dom";

const FamilyList = () => {
  const id = useParams().id;
  const type = "Families";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "name", numeric: false, label: "Name" },
    { id: "pictureUrl", numeric: false, label: "Image" },
    { id: "email", numeric: false, label: "Email" },
    { id: "totalMember", numeric: false, label: "Total Member" },
    { id: "phoneNumber", numeric: false, label: "Phone No" },
    { id: "dropdown1", numeric: false, label: "Status" },
    { id: "description", numeric: false, label: "Description" },
    { id: "created", numeric: false, label: "Created at" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
    id,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default FamilyList;
